import { Component } from 'solid-js'
import { StateMapDisk } from '../../lib/core/state/state_map_disk.enum'

interface Props {
  disk: StateMapDisk,
}

const StateDiskText: Component<Props> = (props) => {
  const getLabel = () => {
    if (props.disk === StateMapDisk.Cloud) {
      return 'Cloud'
    }
    if (props.disk === StateMapDisk.Memory) {
      return 'Memory'
    }
    if (props.disk === StateMapDisk.Export) {
      return 'Export'
    }
    if (props.disk === StateMapDisk.Workspace) {
      return 'Workspace'
    }
    return 'IndexedDB'
  }

  const getColor = () => {
    if (props.disk === StateMapDisk.Cloud) {
      return 'badge bg-info'
    }
    if (props.disk === StateMapDisk.Memory) {
      return 'badge bg-dark'
    }
    if (props.disk === StateMapDisk.Export) {
      return 'badge bg-warning text-dark'
    }
    if (props.disk === StateMapDisk.Workspace) {
      return 'badge bg-success'
    }
    return 'badge bg-secondary'
  }

  const getTitle = () => {
    if (props.disk === StateMapDisk.Export) {
      return 'Future file save/load'
    }
    if (props.disk === StateMapDisk.Workspace) {
      return 'Vite dev workspace map'
    }
    return undefined
  }

  return (
    <span
      class={getColor()}
      style={{ 'margin-left': '5px' }}
      title={getTitle()}
    >
      {getLabel()}
    </span>
  )
}

export default StateDiskText
